import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { store, history } from './store'
import App from './components/App';
import Login from './components/pages/member/login';
import Join from './components/pages/member/join';
import Find from './components/pages/member/find';
import Consulting from './components/pages/consulting';
import { historyManager } from './utils/common'

historyManager.init();

function initService(){
    ReactDOM.render((
        <Provider store={ store }>
            <ConnectedRouter history={ history }>
            <Switch>
                <Route path="/login" component={ Login } />
                <Route path="/join" component={ Join } />
                <Route path="/find" component={ Find } />
                <Route path="/consulting" component={ Consulting } />
                <Route path="/" component={ App } />   
            </Switch>
            </ConnectedRouter>
        </Provider>
    ), document.getElementById('root'));
}

if(window.sessionStorage.getItem('app') == "true" || window.location.search.indexOf("?app") != -1){ // 앱에서 처리할 경우
    document.addEventListener("deviceready", function(){
        initService();
    });
}else{
    initService();
}


// WEBPACK FOOTER //
// ./src/index.js